import { useQuery } from '@tanstack/react-query';
import { fetchCars, RequestBody, PaginatedResponse } from '../services/api';

export const useCars = (filters: RequestBody, page: number = 1, limit: number = 10) => {
    return useQuery<PaginatedResponse, Error>({
        queryKey: ['cars', filters, page, limit],
        queryFn: () => fetchCars(filters, page, limit),
        placeholderData: (previousData) => previousData, // Keep previous data while fetching new page
    });
};
